module.exports = __webpack_public_path__ + "media/images/amenities_icons/water-202637d1e08303edfa16ea3a542d7f11.svg";